import { Link } from "react-router-dom";
import "./Header.css";
import logo from "../../images/logo.svg";
import { useState } from "react";

function Header() {
  const [isActive, setIsActive] = useState(false);
  return (
    <header className="lottolegenda-header">
      <div className="lottolegenda-header__body pad">
        <Link to="/" className="lottolegenda-header__logo">
          <img src={logo} alt="logo vikinglotto" title="logo vikinglotto" />
        </Link>
        <nav className={`lottolegenda-header__nav ${isActive && "active"}`}>
          <div
            className="lottolegenda-header__burger-close"
            onClick={() => setIsActive(false)}
          ></div>
          <Link
            to="/"
            className="lottolegenda-header__link"
            onClick={() => setIsActive(false)}
          >
            Home
          </Link>
          <Link
            to="/how-to-play"
            className="lottolegenda-header__link"
            onClick={() => setIsActive(false)}
          >
            How to play
          </Link>
          <Link
            to="/results"
            className="lottolegenda-header__link"
            onClick={() => setIsActive(false)}
          >
            Draw results
          </Link>
          <Link
            to="/winners"
            className="lottolegenda-header__link"
            onClick={() => setIsActive(false)}
          >
            Winners
          </Link>
          <Link
            to="/about"
            className="lottolegenda-header__link"
            onClick={() => setIsActive(false)}
          >
            About the lottery
          </Link>
        </nav>
        <div
          className="lottolegenda-header__burger-menu"
          onClick={() => setIsActive(true)}
        ></div>
      </div>
    </header>
  );
}

export default Header;
